<script>
    import BaseView      from "../../../../../App/Views/BaseView";
    import ActivePalette from "../../../Store/ActivePalette";
    import Swatches      from "../../../Store/Swatches";

    export default {
        extends: BaseView,

        computed: {
            palette() {
                return this.activePalette.getPalette();
            },

            activeSwatch() {
                return this.activePalette.getActiveSwatch();
            },

            activePalette() {
                return new ActivePalette();
            },

            swatches() {
                return new Swatches(this.palette.id);
            }
        },
    }
</script>
